import actions from './actions'

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/features/operations/store/index.js